module.exports = __webpack_public_path__ + "static/media/bg-right-img-3.c83dc045.jpg";